import AxiosInstance from "./api";

const AccountingStatement6Service = {
  preview: (params) => {
    return AxiosInstance.get("/private/accounting-statement-6/sync/preview", { params });
  },
  sync: (data) => {
    return AxiosInstance.post("/private/accounting-statement-6/sync", data);
  },
  findAll: (params) => {
    return AxiosInstance.get("/private/accounting-statement-6", { params });
  },
  findById: (id) => {
    return AxiosInstance.get(`/private/accounting-statement-6/${id}`);
  },
  delete: (id) => {
    return AxiosInstance.delete(`/private/accounting-statement-6/${id}`);
  },
};

export default AccountingStatement6Service;
